export default __webpack_public_path__ + "static/media/a_wdt_c_3.b896b1b9.mp3";